import * as React from 'react';
import {Button, Col, Input, Row, Tooltip} from "reactstrap";
import {connect} from "react-redux";
import EndingScreen from "./endingScreen";
import {FormattedMessage} from "react-intl";
import LaddaButton, {ZOOM_OUT} from "react-ladda";

function EndingScreensList(props) {
	const {survey, plan} = props;
	const [endingScreens, setEndingScreens] = React.useState(survey.structure.data.survey.endingScreens);
	const allowToCreate = plan.survey.endingScreenNumber > survey.structure.data.survey.endingScreens.length;

	const addNew = () => {
		const newScreen = {
			isDefault: false,
			name: "Nazwa ekranu końcowego",
			content: "Domyślna treść zakończenia",
			id: null
		};

		setEndingScreens([...endingScreens, newScreen])
	}

	return <React.Fragment>
		{endingScreens.map((screen) => {
			return <EndingScreen endingScreen={screen} />
		})}
		{(allowToCreate) && <Row className="mt-3">
			<Col>
				<FormattedMessage id="_.button.save">{
					(message) => <LaddaButton
						className="btn btn-primary btn-ladda mr-2"
						data-style={ZOOM_OUT}
						onClick={() => addNew()}
					>Stwórz nowy ekran zakończenia</LaddaButton>
				}</FormattedMessage>
			</Col>
		</Row>}
	</React.Fragment>
}

EndingScreensList.propTypes = {

};

function mapStateToProps(state) {
	return {
		survey: state.survey,
		plan: state.user.userPlan.plan
	}
}

export default connect(mapStateToProps)(EndingScreensList);